import React, { useEffect } from 'react';

import TabPageContainer from '~components/atoms/TabPageContainer';
import { useAppDispatch, useAppSelector } from '~redux/hooks';
import combinedActions from '~redux/combinedActions';
import CustomerTransferSearchAndFilterBar from './CustomerTransferApprovalSearchAndFilterBar';
import ConfirmUpdateCustomerTransferStatusModal from './ConfirmUpdateCustomerTransferStatusModal';
import CustomerTransferApprovalPaginator from './CustomerTransferApprovalPaginator';
import CustomerTransferApprovalTable from './CustomerTransferApprovalTable';

const CustomerTransferApproval = () => {
    const dispatch = useAppDispatch();

    const customerTransferIndex = useAppSelector(state => state.approval.pendingCustomerTransferListing.index);

    useEffect(() => {
        dispatch(combinedActions.approvalGetPendingCustomerTransferListingAttempt());
    }, [customerTransferIndex, dispatch]);

    return (
        <TabPageContainer>
            <CustomerTransferSearchAndFilterBar />

            <CustomerTransferApprovalTable />

            <CustomerTransferApprovalPaginator />

            <ConfirmUpdateCustomerTransferStatusModal />
        </TabPageContainer>
    );
};

export default CustomerTransferApproval;
